import { Steps, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  get_order,
  OrderAddComments,
  order_add_comments,
  order_get_comments,
  order_history,
  GetOrder,
} from "../../actions/orders";
import message from "../../assets/message.svg";
// import attachment from "../../assets/paperclip.svg";
// import refresh from "../../assets/refresh.svg";
import { NavWrap } from "../ShopForTyres";
import ProdDetailTable from "./ProdDetailTable";
import close from "../../assets/cancel.svg";
import moment from "moment";
import { ScaleLoader } from "react-spinners";

const { Step } = Steps;
const { TabPane } = Tabs;

const MyOrderWrap = (props) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <div className="order-wrap">
      <div className="flex-between">
        <div className="left-sec">
          <label>{props.label}</label>
        </div>
        <div className="right-sec">
          <span
            className="close cursor"
            onClick={() => {
              history.push("/admin/orders", {
                filters: location.state?.filters,
              });
            }}
          >
            <img src={close} alt="icon" width={18} />
          </span>
        </div>
      </div>
      {props.loading ? (
        <div className="flex-center">
          <ScaleLoader color={"#2f2d51"} />
        </div>
      ) : (
        props.children
      )}
    </div>
  );
};
const order_status = {
  Confirmed: "success-text",
  Accepted: "success-text",
  "Awaiting signature": "warn-text",
  "To be confirmed": "warn-text",
  Pending: "warn-text",
  Cancelled: "error-text",
};
const OrderDetail = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const order = useSelector((state) => state?.orders?.single?.data?.order);
  const orderLoading = useSelector((state) => state?.orders?.single?.loading);
  const order_comment = useSelector(
    (state) => state?.orders?.order_add_comments
  );
  const order_comments = useSelector(
    (state) => state?.orders?.order_get_comments?.data?.comments
  );
  const orderHistory = useSelector(
    (state) => state?.orders?.order_history?.data
  );

  const [tab, setTab] = useState("1");
  const [comment, setComment] = useState("");
  const [products, setProducts] = useState([]);
  console.log(location.state?.customer_number);
  useEffect(() => {
    if (location.state && location.state.order_id) {
      dispatch(
        get_order({
          email: localStorage.getItem("email"),
          id: location.state?.order_id,
          customer_name: location.state?.customer_number,
        })
      );
    }
    if (location.state?.order) {
      dispatch({
        type: GetOrder.SUCCESS,
        payload: {
          order: location.state?.order,
        },
      });
    }
    // eslint-disable-next-line
  }, [location.state]);

  useEffect(() => {
    if (order_comment?.success) {
      toast.success("Commented Successfully.");
      setComment("");
      dispatch(
        order_get_comments({
          email: localStorage.getItem("email"),
          order_id: order?.id,
        })
      );
      dispatch({
        type: OrderAddComments.RESET,
      });
    }

    if (
      order_comment?.data?.status === false ||
      order_comment?.success === false
    ) {
      toast.error("Failed to Commented.");
      dispatch({
        type: OrderAddComments.RESET,
      });
    }
    // eslint-disable-next-line
  }, [order_comment]);

  useEffect(() => {
    if (order?.id) {
      dispatch(
        order_get_comments({
          email: localStorage.getItem("email"),
          order_id: order?.id,
        })
      );
    }
    // eslint-disable-next-line
  }, [order]);

  const getAddress = (name) => {
    if (order?.order_sales_nav?.Street) {
      return (
        <>
          <p>
            {name ? (
              <>
                {order?.order_sales_nav?.Name1}
                <br />
              </>
            ) : null}
            {order?.order_sales_nav?.Street}
            {order?.order_sales_nav?.Street && ", "}
            {order?.order_sales_nav?.City1}
            {order?.order_sales_nav?.City1 && ", "}
            <br />
            {order?.order_sales_nav?.Country}
            {order?.order_sales_nav?.Country && ", "}
            {order?.order_sales_nav?.PostCode1}
            <br /> PH : {order?.order_sales_nav?.TelNumber}
          </p>
        </>
      );
    } else {
      return (
        <p>
          {order?.delivery_address?.name}
          <br />
          {order?.delivery_address?.address1} ,{" "}
          {order?.delivery_address?.address2}
          <br />
          {order?.delivery_address?.city}, {order?.delivery_address?.state}{" "}
          {order?.delivery_address?.zip}
          <br /> PH : {order?.delivery_address?.phone}
        </p>
      );
    }
  };

  const checkOrderStatus = (item) => {
    if (item?.Augru !== "Z92" && item?.SoNumber && item?.OrderStatus === "C") {
      return "Completed";
    } else if (item?.Augru !== "Z92" && item?.SoNumber) {
      return "Confirmed";
    } else if (item?.Augru === "Z92") {
      return "Cancelled";
    } else return "To be confirmed";
  };
  const status = checkOrderStatus(order?.order_sales_nav);

  return (
    <NavWrap>
      <div className="card2 prod">
        <MyOrderWrap
          label={"Orders"}
          isSO={order?.so_number}
          loading={orderLoading}
        >
          <div className="details">
            <div>
              <span
                className={`status ${
                  order_status[
                    order?.cancelled_order ? "Cancelled" : order?.order_status
                  ]
                }`}
              >
                {order?.cancelled_order ? "Cancelled" : status}
              </span>
            </div>
            <div className="ord-details">
              <div>
                <div>
                  <span className="nm large">
                    {order?.so_number ? "Sales" : ""} Order Details - #
                    {order?.so_number ? order?.so_number : order?.order_number}
                  </span>
                </div>
                <div>
                  <span className="nm">PO Number - {order?.po_number}</span>
                </div>
                <div>
                  <span className="nm">
                    {"Date & Time : " +
                      moment(order?.date).format("DD/MM/YYYY HH:mm a")}
                  </span>
                </div>
                <div>
                  <span className="nm">
                    Created by : {order?.name} <br />
                    <span className="light">{order?.email}</span>
                  </span>
                </div>
              </div>
              <div className="addr delivery">
                <div>
                  <span className="nm">Delivery Address</span>
                </div>
                {typeof order?.delivery_address === "string" ? (
                  <p>{order?.delivery_address}</p>
                ) : (
                  getAddress(true)
                )}
              </div>
            </div>
          </div>
          <div className="tabs mt1">
            <Tabs
              defaultActiveKey={"1"}
              onTabClick={(val) => {
                setTab(val);
                if (parseInt(val) === 3) {
                  dispatch(
                    order_history({
                      email: localStorage.getItem("email"),
                      order_id: order?.order_number,
                    })
                  );
                }
              }}
            >
              <TabPane active={tab} tab="Product Details" key="1">
                <ProdDetailTable
                  data={order?.line_items}
                  order={order}
                  products={products}
                  setProducts={setProducts}
                />
              </TabPane>
              <TabPane active={tab} tab="Order Details" key="2">
                <section className="od">
                  <div className="row">
                    <span>Delivery Address :</span>
                    {typeof order?.delivery_address === "string" ? (
                      <p>{order?.delivery_address}</p>
                    ) : (
                      getAddress(true)
                    )}
                  </div>
                  {/* <div className="row">
                    <span>Order type :</span>
                    <p>FD</p>
                  </div> */}
                  {/* <div className="row">
                    <span>Payment By :</span>
                    <p>Credit Balance</p>
                  </div> */}
                </section>
              </TabPane>
              <TabPane active={tab} tab="History" key="3">
                <div className="order-history">
                  {orderHistory && orderHistory?.length ? (
                    orderHistory?.map((ele) => {
                      return (
                        <div className="his-item">
                          <span>{ele?.date}</span>
                          <span>{ele?.message}</span>
                        </div>
                      );
                    })
                  ) : (
                    <div className="his-item">
                      <span>No History</span>
                    </div>
                  )}
                </div>
              </TabPane>
            </Tabs>
          </div>
          {order?.id && (
            <div className="d-flex gap2 mt1">
              <div className="w50">
                <div className="tabs">
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Comments">
                      <div className="comments">
                        <Steps size="small" direction="vertical">
                          {Array.isArray(order_comments) &&
                            order_comments?.map((ele) => {
                              return (
                                <Step
                                  title={
                                    <div className="comments">
                                      {ele?.Comments}
                                      <br />
                                      <span>
                                        By:{" "}
                                        {ele?.Createdby === "Omni Admin"
                                          ? "Omni Customer Service Team"
                                          : ele.Createdby}
                                      </span>
                                      <span>
                                        On:{" "}
                                        {moment(ele?.date).format(
                                          "DD/MM/YYYY HH:mm"
                                        )}
                                      </span>
                                    </div>
                                  }
                                  icon={<img src={message} alt="message" />}
                                />
                              );
                            })}
                        </Steps>
                        <div className="comment-wrap">
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              dispatch(
                                order_add_comments({
                                  order_id: order?.id,
                                  comment,
                                })
                              );
                            }}
                          >
                            <input
                              placeholder="Enter Text"
                              name="comment"
                              value={comment}
                              onChange={(e) => {
                                setComment(e.target.value);
                              }}
                            />
                            <button
                              className="green-btn"
                              disabled={order_comment?.loading}
                            >
                              Submit
                            </button>
                          </form>
                        </div>
                      </div>
                    </TabPane>
                  </Tabs>
                </div>
              </div>
              <div className="w50">
                <div className="tabs">
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Status">
                      <div className="status">
                        <div className="ml1 mt1">
                          <Steps
                            direction="vertical"
                            progressDot
                            current={
                              status === "Completed"
                                ? 3
                                : status !== "Confirmed"
                                ? 1
                                : 2
                            }
                          >
                            <Step
                              title={
                                <div className="box">
                                  Order has been placed successfully
                                </div>
                              }
                            />
                            <Step
                              title={
                                <div className="box">Awaiting Confirmation</div>
                              }
                            />
                            <Step
                              title={<div className="box">Confirmed</div>}
                            />
                            <Step
                              title={<div className="box">Completed</div>}
                            />
                          </Steps>
                        </div>
                      </div>
                    </TabPane>
                  </Tabs>
                </div>
              </div>
            </div>
          )}
        </MyOrderWrap>
      </div>
    </NavWrap>
  );
};

export default OrderDetail;
